import { FormArray } from '@angular/forms';

export function answerLength(length: number) {
  return (control: FormArray) => {
    if (control.length > length) {
      return { tooManyItems: true };
    }
    if (control.length < length) {
      return { notEnoughItems: true };
    }
    return null;
  };
}
